export default __webpack_public_path__ + "static/media/drag.145d6b75.svg";